module.exports = __webpack_public_path__ + "static/media/dashboard_manage_deck.2f7b8602.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/dashboard_manage_deck.mp4
// module id = 268
// module chunks = 0